var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "flex flex_gap" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Период")]),
            _vm._v(" "),
            _c("div", [_c("DateRangePicker", { ref: "range" })], 1),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group flex-grow-1" },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Пользователи")]),
              _vm._v(" "),
              _c("CustomMultiSelect", {
                ref: "selectedUsers",
                attrs: { records: _vm.usersForSelect ?? _vm.users },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "align-self-end" },
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Показать",
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                  onClick: () => _vm.getRecords(),
                  className: "btn btn-outline-info",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading || _vm.records
      ? _c("div", { staticClass: "card table_block" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table_div_block" }, [
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-1" },
                  [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", { staticClass: "def_width" }),
                          _vm._v(" "),
                          _vm._l(_vm.dateRange, function (date) {
                            return _c("th", { staticClass: "text-wrap" }, [
                              _vm._v(_vm._s(date)),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.selectedUsers, function (u) {
                        return _vm.hasRecords(u.id)
                          ? _c(
                              "tr",
                              [
                                _c("td", { staticClass: "fixed-side" }, [
                                  _vm._v(_vm._s(u.id) + " " + _vm._s(u.name)),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.dateRange, function (date) {
                                  return _c(
                                    "td",
                                    _vm._l(
                                      _vm.records[date][u.id],
                                      function (s) {
                                        return _c("p", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.shifts[s.work_shift_id]
                                                  ?.title
                                              ) +
                                              "\n                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              class: {
                                                badge: true,
                                                "badge-success": !s.is_active,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.printDate(
                                                    s.created_at,
                                                    "HH:mm"
                                                  )
                                                ) + "\n              "
                                              ),
                                            ]
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e()
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Активация смены")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }